import React from 'react';

import { EmptyTutorial } from '@dashboard/components/empty-states/EmptyTutorial';
import LoadingIndicator from '@dashboard/components/loading/LoadingIndicator';
import {
  EmailMessageEnvironmentFilter,
  EmailMessageEventTypeFilter,
  EmailMessageTimePeriodFilter,
  useEmailMessagesQuery,
  useEmailMessagesReportQuery,
} from '@dashboard/generated/wp/platform';
import useCurrentWpPlatform from '@dashboard/hooks/useCurrentWpPlatform';
import { Link, Typography } from '@mui/material';

function SamplePlatformEmptyPage() {
  const environment = EmailMessageEnvironmentFilter.All;
  const timePeriod = EmailMessageTimePeriodFilter.All;
  const eventType = EmailMessageEventTypeFilter.All;
  useEmailMessagesReportQuery({
    pollInterval: 3000,
    variables: {
      filter: { environment, timePeriod, sourceEmailMessagesBatchId: null },
    },
  });
  useEmailMessagesQuery({
    pollInterval: 3000,
    variables: {
      page: 1,
      filter: { environment, timePeriod, eventType, sourceEmailMessagesBatchId: null },
    },
  });
  return <LoadingIndicator />;
}

export default function EmptyPageTutorial() {
  const { data } = useCurrentWpPlatform();
  const platform = data?.Platform;

  if (!platform) {
    return null;
  }

  const { activeWaypointTier } = platform;
  if (activeWaypointTier === 'SAMPLE') {
    return <SamplePlatformEmptyPage />;
  }

  return (
    <EmptyTutorial
      description={
        <>
          <Typography variant="h4" gutterBottom>
            You haven't sent an email yet
          </Typography>
          <Typography color="text.secondary">
            {' '}
            Send an email to create your first activity log.{' '}
            <Link href="https://www.usewaypoint.com/docs/quickstart" target="_blank">
              View our quick start guide
            </Link>
            .
          </Typography>
        </>
      }
      videoSource="https://assets.usewaypoint.com/teaser-activity-list-voiceover.mp4"
      videoTitle="Video teaser of activity on Waypoint"
    />
  );
}
